<template>
    <div>
        <v-container>
            <v-card>
                <v-card-title class="headline grey lighten-4 d-flex justify-space-between">
                    <h3 class="font-weight-700 custom-headline color-custom-blue">Add-On</h3>
                    <v-btn class="custom-bold-button white--text " small color="cyan" @click="addonDialog = true">
                        <v-icon>mdi-plus</v-icon>ADD ADD-ON
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <span class="d-flex"></span>
                    <v-card>
                        <v-card-text>
                            <table width="100%">
                                <thead>
                                    <tr style="background-color: #e5e1e1">
                                        <th style="text-align: center; font-weight: bold">S.no</th>
                                        <th style="text-align: center; font-weight: bold">Name</th>
                                        <th style="text-align: center; font-weight: bold">Price</th>
                                        <th style="text-align: center; font-weight: bold">Delete</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <template v-if="selectedAddOnList?.length > 0">
                                    <tr v-for="(row, index) in selectedAddOnList" :key="index"
                                        style="border-bottom: 1px solid #ddd;"
                                        :class="index % 2 != 0 ? 'bg-light' : ''">
                                        <td align="center" valign="middle" style="padding: 10px">
                                            {{ index + 1 }}
                                        </td>
                                        <td align="center" valign="middle"
                                            style="padding: 10px; font-weight: 500; font-size: 14px">
                                            {{ row.name }}
                                        </td>

                                        <td align="center" valign="middle" style="padding: 10px">
                                            <v-text-field class="mt-2" solo flat dense filled hide-details
                                                style="width: 60px;" v-model="row.price"></v-text-field>
                                        </td>
                                        <td align="center">
                                            <v-tooltip top content-class="custom-top-tooltip">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon @click="selectedAddOnList.splice(index, 1)"
                                                        color="deep-orange" v-bind="attrs" v-on="on">
                                                        mdi-delete
                                                    </v-icon>
                                                </template>
                                                <span>Click here to delete </span>
                                            </v-tooltip>
                                        </td>
                                    </tr>
                                </template>
                                <tr v-else>
                                    <td colspan="6" class="py-4">
                                        <p class="m-0 row-not-found text-center font-weight-500 font-size-16">
                                            <img :src="$assetURL('media/error/empty.png')"
                                                class="row-not-found-image" />
                                            Uhh... There are no Addons at this moment.
                                        </p>
                                    </td>
                                </tr>
                            </table>
                        </v-card-text>
                    </v-card>
                </v-card-text>
            </v-card>
        </v-container>
        <AssignAddonDialog :addon-dialog="addonDialog" v-on:close="addonDialog = false"
            :selected-addon-list="selectedAddOnList" />
    </div>
</template>
<script>
import AssignAddonDialog from "@/view/components/AssignAddonDialog.vue";
import { ServiceEventBus } from "@/core/lib/service/service.lib";

export default {
    model: {
        prop: "value",
        event: "change",
    },
    components: {
        AssignAddonDialog
    },
    data() {
        return {
            selectedAddOnList: [],
            service_id: 0,
            addonDialog: false
        }
    },
    props: {
        selectedAddOnListProp: {
            type: Array,
            default: null
        },
    },

    mounted() {
        this.service_id = Number(this.$route.params?.id);
    },
    created() {
        ServiceEventBus.$on("update:addons", (argument) => {
            this.selectedAddOnList.push(...argument);
        });
        setTimeout(() => {
            if (this.selectedAddOnListProp && this.service_id > '0') {
                this.selectedAddOnList = this.selectedAddOnListProp;
            }
        }, 1000);
    },
    watch: {
        selectedAddOnList: {
            deep: true,
            immediate: true,
            handler(param) {
                console.log(param);
                this.$emit('updateSelectedAddOnList', param);
            },
        },
    },
    computed: {

    },
    methods: {
        updateAddons() {

        },
    },
}
</script>